import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  root: {
    padding: '0.75rem 1rem',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[80],
    borderRadius: '0.5rem',
    backgroundColor: neutral.white,
    border: `1px solid ${neutral[90]}`,
    '&:hover': {
      color: neutral[100],
      borderColor: neutral[100],
      backgroundColor: neutral[10],
    },
  },
});
